export enum VoivodeshipNames {
  PODLASKIE = "podlaskie",
  WARMINSKO_MAZURSKIE = "warminsko-mazurskie",
  POMORSKIE = "pomorskie",
  ZACHODNIO_POMORSKIE = "zachodnio-pomorskie",
  LUBUSKIE = "lubuskie",
  WIELKOPOLSKIE = "wielkopolskie",
  LODZKIE = "lodzkie",
  KUJAWSKO_POMORSKIE = "kujawsko-pomorskie",
  MAZOWIECKIE = "mazowieckie",
  LUBELSKIE = "lubelskie",
  SWIETOKRZYSKIE = "swietokrzyskie",
  PODKARPACKIE = "podkarpackie",
  MALOPOLSKIE = "malopolskie",
  SLASKIE = "slaskie",
  OPOLSKIE = "opolskie",
  DOLNOSLASKIE = "dolnoslaskie",
}
